import {
	ApolloClient,
	InMemoryCache,
	createHttpLink,
	defaultDataIdFromObject,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getAuth } from "firebase/auth";

import config from "../config.json";

export const createApolloClient = () => {
	const httpLink = createHttpLink({
		uri: config.graphqlUrl,
		options: {
			reconnect: true,
		},
	});

	const authLink = setContext(async (_, { headers }) => {
		const token = await getAuth().currentUser?.getIdToken();
		// return the headers to the context so httpLink can read them
		// const kek = await getAuth().currentUser?.getIdTokenResult();
		// alert(new Date(kek.expirationTime));
		return {
			headers: {
				...headers,
				fbtoken: token,
			},
		};
	});

	return new ApolloClient({
		link: authLink.concat(httpLink),
		cache: new InMemoryCache({
			dataIdFromObject(responseObject) {
				switch (responseObject.__typename) {
					case "Coordinate":
						return `Coordinate:${responseObject.trackId}`;
					default:
						return defaultDataIdFromObject(responseObject);
				}
			},
		}),
	});
};

// export const createClient = (errorHandler) => {
// 	const httpLink = createHttpLink({
// 		uri: `${process.env.REACT_APP_GRAPHQL_URL}/graphql`,
// 	});

// 	const authLink = setContext((_, { headers }) => {
// 		const auth = getAuth();
// 		auth.onAuthStateChanged();
// 		// get the authentication token from local storage if it exists

// 		// return the headers to the context so httpLink can read them
// 		return {
// 			headers: {
// 				...headers,
// 				// Authorization: `Bearer ${tofken || "NONE"}`,
// 			},
// 		};
// 	});
// 	// const httpLink = new HttpLink({uri: `${process.env.REACT_APP_GRAPHQL_URL}/graphql`})
// 	//
// 	// const middlewareLink = new ApolloLink((operation, forward) => {
// 	//     operation.setContext({
// 	//         headers: {
// 	//             Authorization: `Bearer ${localStorage.getItem("jwtToken") || "NONE"}`,
// 	//             timezone: new Date().getTimezoneOffset() / 60
// 	//         }
// 	//     })
// 	//     return forward(operation)
// 	// })
// 	// const afterErrorLink = onError((error) => {
// 	//     errorHandler(error)
// 	// })
// 	// const httpLinkWithMiddleware = middlewareLink.concat(afterErrorLink).concat(httpLink)
// 	//
// 	// const link = split(
// 	//     ({query}) => {
// 	//         const definition = getMainDefinition(query)
// 	//         return definition.kind === "OperationDefinition" && definition.operation === "subscription"
// 	//     },
// 	//     httpLinkWithMiddleware
// 	// )

// 	return new ApolloClient({
// 		link: authLink.concat(httpLink),
// 		cache: new InMemoryCache(),
// 	});
// };

export default createApolloClient;
